import AclTabViewContainer from 'js/components/elements/aclView/AclTabViewContainer';
import ReusableTxOverviewTabContainer from 'js/components/reusableTransforms/cards/ReusableTxOverviewTabContainer';
import { ACL_RESOURCE_TYPE_TRANSFORM } from 'js/constants/aclConstants';
import {
  RESOURCE_TYPE_ATTR_TRANSFORM,
  RESOURCE_TYPE_RECORD_TRANSFORM,
} from 'js/constants/resourceTypes';
import { TransformParameterTypes } from 'js/constants/schemaEditor';
import { TransformType } from 'new/components/ReusableTransform/types';
import { ResourceActivity } from 'new/elements/support/detailTabs/ResourceActivity';
import React from 'react';
import JSONUtils from 'js/lib/JSONUtils';
import flat from 'flat';
import keys from 'lodash/keys';

const SELECTION_OPTIONS_TYPE = [
  { title: 'Attribute', value: TransformParameterTypes.ATTR_REF },
  { title: 'String', value: TransformParameterTypes.STRING_INP },
  { title: 'Number', value: TransformParameterTypes.NUMBER_INP },
];

const getCurrentOptionValue = (currentParams: any[], atIndex = 0) => {
  let currentValue = null;
  let currentType = null;

  const currentParam = currentParams[atIndex];
  const indexExceedsCurrentParams = atIndex > currentParams.length;
  const typeIsUndefined = currentParam?.type === undefined;

  if (indexExceedsCurrentParams || typeIsUndefined) {
    return { currentType, currentValue };
  }

  currentType = currentParam.type;

  if (currentType === TransformParameterTypes.ATTR_REF) {
    currentValue = currentParam.name;
  } else {
    currentValue = currentParam.value ?? '';
  }

  if (currentValue === null && currentType === TransformParameterTypes.STRING_INP) {
    currentValue = SELECTION_OPTIONS_TYPE[0]?.title;
  }

  return { currentType, currentValue };
};

function generateTabs(card: any) {
  const tabs = [
    {
      tabName: 'Overview',
      tabElement: <ReusableTxOverviewTabContainer />,
    },
  ];

  if (card) {
    const resourceType =
      card.output_type === TransformType.ATTRIBUTE
        ? RESOURCE_TYPE_ATTR_TRANSFORM
        : RESOURCE_TYPE_RECORD_TRANSFORM;

    tabs.push({
      tabName: 'Activity',
      tabElement: <ResourceActivity resourceType={resourceType} data={{}} />,
    });
  }

  tabs.push({
    tabName: 'Access',
    tabElement: <AclTabViewContainer resourceType={ACL_RESOURCE_TYPE_TRANSFORM} />,
  });

  return tabs;
}

function generatingInputAttributesFor(inputSamples) {
  if (!inputSamples) return [];
  const codeObj = JSONUtils.parseJson(inputSamples, true);
  const inputAttrsObj = codeObj ? flat(codeObj, { safe: true }) : null;
  return inputAttrsObj ? keys(inputAttrsObj) : [];
}

export const ReusableTransformUtil = {
  SELECTION_OPTIONS_TYPE,
  getCurrentOptionValue,
  generateTabs,
  generatingInputAttributesFor,
};
